import { Flex, InfoIcon, Tag, Typography } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

interface FormSectionOptions {
  defaultOption?: boolean;
  label: string;
  value: string | boolean;
}
interface FormSectionProps {
  helperText?: string;
  name: string;
  options: FormSectionOptions[];
  subtitle: string;
  title: string;
}

export const FormSection = ({
  name,
  title,
  subtitle,
  helperText,
  options,
}: FormSectionProps) => {
  const { setValue } = useFormContext();

  const handleOptionChange = (option: string | boolean) => {
    setValue(name, option, { shouldDirty: true });
  };

  const radioOptions = useMemo(() => {
    return options.map(({ value, label, defaultOption }, index) => {
      return {
        id: value.toString(),
        value,
        label,
        wrapper: (children: ReactNode) => (
          <Flex
            mb={index === options.length - 1 ? 0 : 16}
            justifyContent="space-between"
            border="grays-light"
            p={16}
            ariaLabel={label}
            onClick={() => handleOptionChange(value)}
            borderRadius="sm"
          >
            {children}
            {defaultOption && (
              <Tag label="Default" background="grays-ultralight" size="sm" />
            )}
          </Flex>
        ),
      };
    });
  }, [options]);

  return (
    <Flex flexDirection="column" mb={24}>
      <Typography variant="body-bold">{title}</Typography>
      <Typography variant="mini" color="grays-mid" mb={8}>
        {subtitle}
      </Typography>
      <Form.RadioFieldGroup
        typography="mini"
        name={name}
        options={radioOptions}
      />
      {helperText && (
        <Flex alignContent="center" mt={12}>
          <InfoIcon size="sm" mr={12} mt={4} color="grays-mid" />
          <Typography variant="mini" width={'90%'} color="grays-mid">
            {helperText}
          </Typography>
        </Flex>
      )}
    </Flex>
  );
};
